import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`Changes the tax `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#roundingmode"
        }}>{`RoundingMode`}</a>{` of a cart. When changing the tax rounding mode, the taxes are recalculated.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"changeTaxRoundingMode"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`taxRoundingMode`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#roundingmode"
          }}>{`RoundingMode`}</a></li>
      </ul>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      